const isOpen = (element) => {
  return element.hasAttribute("open");
};

document.addEventListener("DOMContentLoaded", function () {
  const headerSubMenuElements = document.querySelectorAll(
    "header ul.list-menu .header__submenu"
  );

  headerSubMenuElements.forEach((item) => {
    const detailDisclosure = item.closest("details-disclosure");
    if (detailDisclosure) {
      const detailsContainer = detailDisclosure.querySelector("details");
      const summaryContainer = detailsContainer.querySelector("summary");

      detailsContainer.addEventListener("mouseenter", function () {
        if (!isOpen(detailsContainer)) {
          detailsContainer.setAttribute("open", "");
          summaryContainer.setAttribute("aria-expanded", true);
        }
      });

      detailsContainer.addEventListener("mouseleave", function () {
        if (isOpen(detailsContainer)) {
          detailsContainer.removeAttribute("open");
          summaryContainer.setAttribute("aria-expanded", false);
        }
      });
      
    }
  });

  if (document.querySelector("#banner_animated_text")) {
    const rows = document.querySelectorAll("#banner_animated_text");

    function setRowsCssWidthVariable() {
      rows.forEach((item) => {
        const currentRowWidth = item.offsetWidth;
        console.log(currentRowWidth);
        item.style.cssText = `--row-width:${currentRowWidth}px`;
      });
    }

    window.addEventListener("load", function () {
      setRowsCssWidtVariable();
    });

    window.addEventListener("resize", function () {
      setRowsCssWidtVariable();
    });
  }
});


document.addEventListener("DOMContentLoaded", function() {
  const reviewComments = document.querySelectorAll('.review_comment');
  const maxHeight = 90; 
  

 
  function toggleReview(comment, button) {
    const isCollapsed = !comment.classList.contains('expanded'); 

    if (isCollapsed) {
      comment.classList.add('expanded'); 
      button.textContent = 'Show Less'; 
      comment.style.maxHeight = 'none'; 
    } else {
      comment.classList.remove('expanded'); 
      button.textContent = 'Read More...'; 
      comment.style.maxHeight = `${maxHeight}px`; 
    }
  }

  // Проверяем высоту текста и отображаем "Read More..." при необходимости
  reviewComments.forEach((comment, index) => {
    const commentHeight = comment.scrollHeight; 
    const readMoreBtn = comment.nextElementSibling; 

    // Если высота текста больше максимальной высоты контейнера
    if (commentHeight > maxHeight) {
      readMoreBtn.style.display = 'block'; 
      comment.style.maxHeight = `${maxHeight}px`; 
      comment.style.overflow = 'hidden'; 

      // Добавляем обработчик событий для кнопки "Read More..."
      readMoreBtn.addEventListener('click', function() {
        toggleReview(comment, readMoreBtn); 
      });
    } else {
      // Если текст меньше, кнопка не нужна и остаётся скрытой
      readMoreBtn.style.display = 'none';
    }
  });
});


